import { render } from "./BulkUpload.vue?vue&type=template&id=1584fee8"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__